import SharedData from './SharedData';
export const CONSTANTS = {
    ApplicationName: 'Retro Puzzle Maker' + (window.location.host?.startsWith('puzzle-next') ? ' (PRE-RELEASE)' : ''),
    MobileCollapseWidth: 576,
    PopularGamesEnabled: false,
    Auth0Domain: 'cpprograms.auth0.com',
    Auth0ClientId: 'WSUwQt7Hg4EpfdaXesvOwTWa4Au4olrx',
    PuzzleApiUrl: 'https://puzzle-api.nes.science',
    GameS3Url: 'https://s3-puzzle-nes-science-v2-dev.s3.amazonaws.com/games/',
    BinariesUrl: 'https://hosted-binaries.nes.science/nes-puzzle-maker/',
    LatestBinariesUrl: 'https://hosted-binaries.nes.science/nes-puzzle-maker/' + SharedData.appVersion + '/',
    OlderVersions: SharedData.availableAppVersions.slice(0, -1),
    Binaries: {
        "Windows (64 Bit)": "nes-puzzle-maker-win32-x64.zip",
        "Windows (32 Bit)": "nes-puzzle-maker-win32-ia32.zip",

        // The mac binary seems to be corrupted beyond repair; hide it and move on.
        // Mac support has been fully removed because it was an absolute nightmare to try to build/support. Sorry!
        // "Mac": "nes-puzzle-maker-darwin-x64.zip",

        "Linux (64 Bit)": "nes-puzzle-maker-linux-x64.tar.gz",
        "Linux (32 Bit)": "nes-puzzle-maker-linux-ia32.tar.gz",
        "Linux (Arm)": "nes-puzzle-maker-linux-armv7l.tar.gz",
        "Linux (Arm64)": "nes-puzzle-maker-linux-arm64.tar.gz"
    },
    GithubRepoUrl: 'https://gh.nes.science/nes-puzzle-maker-rom',
    GithubTag: "rom-" + SharedData.romVersion,
    RomUrl: window.isSoloApp ? 
        '/latest-rom.nes' :
        'https://s3.amazonaws.com/cpprograms-nes-games-https/retro-puzzle-maker-' + SharedData.romVersion + '.nes?r=1',
    ZipDownloadUrl: window.isSoloApp ? 
        '/latest-rom.zip' : 
        `https://s3.amazonaws.com/cpprograms-nes-games-https/retro-puzzle-maker-${SharedData.romVersion}.zip?r=1`,
    Version: SharedData.appVersion
};